import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";
import { Value } from "devextreme-react/range-selector";
import { logDebugSilently } from "../../../modules/logger";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  revalidateFields?: string[];
  options?: RegisterOptions;
  children?: React.ReactNode;
  step?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  showWhenIsDisabled?: boolean;
  min?: number;
  max?: number;
  tooltipCallBack?: () => string | undefined;
}

const NumberEditor = ({ label, fieldName, formHook, revalidateFields, options, step, children, tooltipId, isDisabled, showWhenIsDisabled, min, max, tooltipCallBack }: IProps) => {
  const { register, formState, resetField, unregister } = formHook;
  const globalData = useGlobalData();

  const errors = formState.errors;
  const isInValid: any = getValueByString(errors, fieldName);

  if (label === "Vid reducerat flöde med reglerbara rumsdon- ange normal andel av aggregatets maxflöde (%)") {
    logDebugSilently("NumberEditor.tsx: isInValid: ", isInValid);
  }

  // Prepare registration options - ensure it's always a valid object
  const registrationOptions: RegisterOptions = options ? { ...options } : {};

  if (!registrationOptions.valueAsNumber && !registrationOptions.setValueAs) {
    registrationOptions.valueAsNumber = true;
  }

  // Keep field value in form state even when disabled to prevent uncontrolled to controlled warning
  if (registrationOptions.shouldUnregister === undefined) {
    registrationOptions.shouldUnregister = false;
  }

  // If disabled and not shown, mark as disabled in React Hook Form
  // This excludes it from validation and form submission
  if (isDisabled && !showWhenIsDisabled) {
    registrationOptions.disabled = true;
  }

  const registered = register(fieldName, registrationOptions);

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipCallBack)
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{tooltipCallBack()}</span>
        </Tooltip>
      );
    else if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const getNumberEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <div className={(children ? "input-group" : "") + " w-100"}>
        <OverlayTrigger placement="top" overlay={renderTooltip}>
          {isDisabled ? (
            showWhenIsDisabled ? (
              <input id={label} type="number" disabled={true} {...registered} className="form-control" />
            ) : (
              <input key={"myUniqueValue"} type="number" disabled={true} className={"form-control"} />
            )
          ) : (
            <input
              id={label}
              type="number"
              min={min}
              max={max}
              step={step}
              disabled={isDisabled}
              {...registered}
              {...(revalidateFields && revalidateFields.length
                ? {
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      registered.onChange(e);
                      // Trigger validation on current field and related fields after value updates
                      setTimeout(() => {
                        formHook.trigger([fieldName, ...revalidateFields]);
                      }, 0);
                    },
                  }
                : {})}
              className={"form-control " + (isInValid ? "is-invalid" : "")}
            />
          )}
        </OverlayTrigger>

        {children}
        {/* {errors[fieldName]?.message && <div className="invalid-feedback">{errors[fieldName]?.message?.toString()}</div>} */}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getNumberEditor()}</>;
};

export default NumberEditor;
